import { render, staticRenderFns } from "./deliveryPlanAction1.vue?vue&type=template&id=bc63224e&scoped=true"
import script from "./deliveryPlanAction1.vue?vue&type=script&lang=js"
export * from "./deliveryPlanAction1.vue?vue&type=script&lang=js"
import style0 from "./deliveryPlanAction1.vue?vue&type=style&index=0&id=bc63224e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc63224e",
  null
  
)

export default component.exports